import Pill from 'ext-ui/components/Pill/Pill'
import React from 'react'
import { useTypingEffect } from 'src/hooks'
import { Blink } from 'src/style/keyframeUtils'

interface AgentChatPromptButtonProps {
  id?: string
  icon?: React.ReactElement
  showCursor?: boolean
  prompt: string
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void
  typingSpeed?: number
}
const AgentPromptButton: React.ForwardRefRenderFunction<
  HTMLDivElement,
  AgentChatPromptButtonProps
> = (props, ref) => {
  const [animatedLabel, isDoneTyping] = useTypingEffect(
    props.prompt,
    props.typingSpeed,
  )

  return (
    <Pill
      ref={ref}
      id={props.id}
      size={'large'}
      color={'new'}
      onClick={(e): void => props.onClick(e)}
    >
      <div className={'flex-row gap-1'}>
        {props.icon}
        <div>
          {animatedLabel}
          {props.showCursor && (
            <span css={isDoneTyping ? Blink() : ''}>{'|'}</span>
          )}
        </div>
      </div>
    </Pill>
  )
}

export default React.forwardRef(AgentPromptButton)
